import { render } from "./upload-auto.vue?vue&type=template&id=7efb7fdb"
import script from "./upload-auto.vue?vue&type=script&lang=js"
export * from "./upload-auto.vue?vue&type=script&lang=js"

import "./upload-auto.vue?vue&type=style&index=0&id=7efb7fdb&lang=less"

import exportComponent from "/Users/jixubin/yunsi/bzcircle-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__